import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import DotsLoading from '../../../components/dotsLoading';
import Header from '../../../components/header';
import EmptyList from '../../../assets/image/shared/empty_list.svg';

import useGetMyAdds from './hooks/useGetMyAdds';
import MyAdItem from './item';
import {googleAnalyticsInstance} from '../../../utilities/helper/googleAnalitics';

const MyAds = () => {
  const {data, fetchNextPage, isLoading, refetch} = useGetMyAdds();
  const event: IGoogleEvent = {
    category: 'my-ads-page-checked',
    action: 'کاربر وارد صفحه آگهی های من شد',
  };
  googleAnalyticsInstance.eventGoogleAnalytics(event);

  return (
    <>
      <Header title="آگهی های من" />

      <InfiniteScroll
        dataLength={data?.pages.flatMap(x => x.results).length || 0} //This is important field to render the next data
        next={() => {
          fetchNextPage();
        }}
        style={{overflow: 'inherit'}}
        className="container  overflow-inherit"
        hasMore={!!data?.pages[data?.pages.length - 1].next}
        loader={
          <div className="my-3">
            <DotsLoading />
          </div>
        }
        scrollableTarget="scrollableDiv"
      >
        {isLoading ? (
          <DotsLoading />
        ) : (
          <>
            {data?.pages?.flatMap(x => x.results) &&
            data?.pages?.flatMap(x => x.results)?.length > 0 ? (
              <>
                {React.Children.toArray(
                  data?.pages
                    .flatMap(x => x.results)
                    ?.map(product => (
                      <MyAdItem
                        refetch={refetch}
                        route={
                          product.status === 'published'
                            ? `/profile/my-ads/details/${product?.guid}`
                            : ''
                        }
                        post={product}
                        icon={product.input_group.icon}
                        inputGroupType={product.input_group?.code}
                      />
                    )),
                )}
              </>
            ) : (
              <>
                {' '}
                <div className="mt-5 pt-5 text-center">
                  <img src={EmptyList} alt="موردی برای نمایش موجود نیست" />
                </div>
              </>
            )}
          </>
        )}
      </InfiniteScroll>
    </>
  );
};

export default MyAds;
